module.exports = __webpack_public_path__ + "static/media/kr.black.0e9d828e.svg";